export const COST_REVIEW_MODAL_OPEN = 'COST_REVIEW_MODAL_OPEN';
export const costReviewModalOpen = (fulfillmentPlanIds) => ({
  type: COST_REVIEW_MODAL_OPEN,
  fulfillmentPlanIds,
});

export const BULK_COST_REVIEW_JOB_STARTED = 'BULK_COST_REVIEW_JOB_STARTED';
export const bulkCostReviewJobStarted = (jobGuid) => ({
  type: BULK_COST_REVIEW_JOB_STARTED,
  jobGuid,
});

export const BULK_COST_REVIEW_JOB_SUCCESS = 'BULK_COST_REVIEW_JOB_SUCCESS';
export const bulkCostReviewJobSuccess = () => ({
  type: BULK_COST_REVIEW_JOB_SUCCESS,
});

export const BULK_COST_REVIEW_JOB_ERROR = 'BULK_COST_REVIEW_JOB_ERROR';
export const bulkCostReviewJobError = () => ({
  type: BULK_COST_REVIEW_JOB_ERROR,
});

export const COST_REVIEW_MODAL_CLOSE = 'COST_REVIEW_MODAL_CLOSE';
export const costReviewModalClose = () => ({
  type: COST_REVIEW_MODAL_CLOSE,
});

export const BULK_COST_REVIEW_APPLY_RECOMMENDATIONS = 'BULK_COST_REVIEW_APPLY_RECOMMENDATIONS';
export const bulkCostReviewApplyRecommendations = ({
  costReviewJobGuid,
  bulkUpdateJobGuid,
  serviceFilters,
  insuranceFilters,
  rateShopperFilters,
  isRateShopperRecommendationsEnabled,
}) => ({
  type: BULK_COST_REVIEW_APPLY_RECOMMENDATIONS,
  jobGuid: costReviewJobGuid,
  bulkUpdateJobGuid,
  serviceFilters,
  insuranceFilters,
  rateShopperFilters,
  isRateShopperRecommendationsEnabled,
});

export const BULK_COST_REVIEW_APPLY_RECOMMENDATIONS_SUCCESS = 'BULK_COST_REVIEW_APPLY_RECOMMENDATIONS_SUCCESS';
export const bulkCostReviewApplyRecommendationsSuccess = (costReviewJobGuid, amountSaved) => ({
  type: BULK_COST_REVIEW_APPLY_RECOMMENDATIONS_SUCCESS,
  jobGuid: costReviewJobGuid,
  amountSaved,
});

export const BULK_COST_REVIEW_APPLY_RECOMMENDATIONS_ERROR = 'BULK_COST_REVIEW_APPLY_RECOMMENDATIONS_ERROR';
export const bulkCostReviewApplyRecommendationsError = (costReviewJobGuid) => ({
  type: BULK_COST_REVIEW_APPLY_RECOMMENDATIONS_ERROR,
  jobGuid: costReviewJobGuid,
});

export const RELOAD_COST_REVIEW = 'RELOAD_COST_REVIEW';
export const reloadCostReview = (jobGuid) => ({
  type: RELOAD_COST_REVIEW,
  jobGuid,
});
